import styled, { css } from 'styled-components'

import { mq, sizes } from '../../theme'
import A from '../A'

export const Container = styled.nav`
  ${({ theme }) => theme.textStyles.text_bold_condensed_16}
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: ${({ theme }) => theme.colors.pureBlack};
`

export const Links = styled.ul`
  display: flex;
  flex-flow: row nowrap;
  list-style: none outside;
  height: 50%;
`

export const LinksItem = styled.li<{ isSeparated?: boolean }>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  ${({ isSeparated, theme }) =>
    isSeparated &&
    css`
      &:not(:first-child) {
        padding-left: 1rem;
        margin-left: 1rem;
        border-left: 2px solid ${theme.colors.greyDD ?? 'lightgrey'};
      }
    `}
`

export const LinksLink = styled(A)<{
  isCurrent?: boolean
  $currentLevelOneOpen?: boolean
}>`
  ${({ theme }) => theme.textStyles.text_bold_condensed_16}
  font-weight: 700;
  ${({ theme, isCurrent, $currentLevelOneOpen }) =>
    isCurrent || $currentLevelOneOpen
      ? css`
          text-decoration-line: underline;
          text-decoration-style: solid;
          text-decoration-thickness: 5px;
          text-decoration-color: ${theme.colors.greenEmerald ?? 'green'};
        `
      : css`
          text-decoration: none;
        `}
  display: block;
  padding: 1rem 1rem;
  text-align: center;
  color: ${({ theme, isCurrent }) =>
    isCurrent ? theme.colors.greenApple : theme.colors.pureBlack ?? 'black'};

  &:hover {
    color: ${({ theme, isCurrent }) =>
      isCurrent ? theme.colors.greenApple : theme.colors.pureBlack ?? 'black'};
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-thickness: ${({ isCurrent }) =>
      isCurrent ? '5px' : '5px'};
    text-underline-position: under;
    text-decoration-color: ${({ theme, isCurrent }) =>
      isCurrent
        ? theme.colors.greenEmerald
        : theme.colors.greenEmerald ?? 'green'};
  }

  @media ${mq(sizes.mangerBougerTablet)} {
    ${({ theme }) => theme.textStyles.text_bold_condensed_15}
  }

  @media ${mq(sizes.mangerBougerDesktop)} {
    ${({ theme }) => theme.textStyles.text_bold_16}
    padding: 0 2.5rem;
  }

  @media ${mq(sizes.boxContent + 50)} {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
`
